"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ToolbarButtonGroup = void 0;
var _styled = _interopRequireDefault(require("@emotion/styled"));
var _lodestarUtils = require("@smartsheet/lodestar-utils");
var _react = _interopRequireWildcard(require("react"));
var _useTheme = require("../../../theme/utils/useTheme");
var _ToolbarSizeContext = require("../context/ToolbarSizeContext");
var _ToolbarSeparator = require("../styled/ToolbarSeparator");
var _utils = require("../utils");
const ToolbarBtnGroupContainmentHeight = "28px";
const containmentVariantMap = (height, toolbarSize) => ({
  default: {
    height: toolbarSize === "xxSmall" ? `${height}px` : `${height - _utils.TOOLBAR_VERT_PADDING * 2}px`
  },
  full: {
    height: ToolbarBtnGroupContainmentHeight
  }
});
const StyledButtonGroup = (0, _styled.default)("div")`
    height: ${_ref => {
  let {
    containmentVariant,
    height,
    toolbarSize
  } = _ref;
  return containmentVariantMap(height, toolbarSize)[containmentVariant].height;
}};
    display: flex;
    align-items: center;
    flex-direction: row;
`;
const StyledInnerWrapper = (0, _styled.default)("span")`
    display: flex;
    gap: var(--sds--toolbar-button-group--gap, 4px);
    align-items: center;
    height: ${_ref2 => {
  let {
    containmentVariant,
    height,
    toolbarSize
  } = _ref2;
  return containmentVariantMap(height, toolbarSize)[containmentVariant].height;
}};
`;
const ToolbarButtonGroup = /*#__PURE__*/(0, _react.forwardRef)((_ref3, ref) => {
  let {
    children,
    className,
    containmentVariant = "default"
  } = _ref3;
  const [isLast, setIsLast] = (0, _react.useState)(false);
  const {
    key
  } = (0, _useTheme.useTheme)();
  const themeMode = key;
  const localRef = (0, _react.useRef)(null);
  const internalRef = (0, _lodestarUtils.useForkRef)(ref, localRef);
  const {
    toolbarSize
  } = (0, _react.useContext)(_ToolbarSizeContext.ToolbarSizeContext);

  /**
   * Disabled to allow updating isLast state after a DOM change
   * (i.e. conditionally rendering content after the group previously marked as last)
   * Only DOM and prop changes will trigger this effect and, since
   * state is only changed for last and previously last element
   * it won't trigger an infinite loop
   */
  // eslint-disable-next-line react-hooks/exhaustive-deps
  (0, _react.useLayoutEffect)(() => {
    setIsLast(!localRef.current?.nextSibling);
  });
  return /*#__PURE__*/_react.default.createElement(StyledButtonGroup, {
    ref: internalRef,
    className: className,
    height: (0, _utils.getToolbarHeight)(toolbarSize),
    toolbarSize: toolbarSize,
    themeMode: themeMode,
    containmentVariant: containmentVariant
  }, /*#__PURE__*/_react.default.createElement(StyledInnerWrapper, {
    containmentVariant: containmentVariant,
    height: (0, _utils.getToolbarHeight)(toolbarSize),
    toolbarSize: toolbarSize
  }, children), !isLast && /*#__PURE__*/_react.default.createElement(_ToolbarSeparator.ToolbarSeparator, {
    containmentVariant: containmentVariant,
    toolbarSize: toolbarSize
  }));
});
exports.ToolbarButtonGroup = ToolbarButtonGroup;
ToolbarButtonGroup.displayName = "ToolbarButtonGroup";
//# sourceMappingURL=ToolbarButtonGroup.js.map